// Archivo: src/hooks/useCloseOnScroll.js
import { useEffect } from 'react';

/**
 * Hook personalizado que ejecuta una función (callback) cuando se detecta un scroll.
 * Por defecto, se registra sobre window, pero si se pasa un targetElement, se usa ese.
 *
 * @param {Function} callback - Función a ejecutar cuando se produce un scroll.
 * @param {HTMLElement|null} targetElement - Elemento en el que se escucha el scroll. Si es null, se usa window.
 */
function useCloseOnScroll(callback, targetElement = null) {
  useEffect(() => {
    // Determinamos el elemento en el que se agregará el listener.
    const scrollTarget = targetElement || window;

    // Definimos la función que se ejecuta con el evento scroll.
    function handleScroll(event) {
      if (scrollTarget === window) {
        console.log('[useCloseOnScroll] Scroll detectado en window. window.scrollY:', window.scrollY);
      } else {
        //console.log('[useCloseOnScroll] Scroll detectado en targetElement. scrollTop:', scrollTarget.scrollTop);
      }
      callback(event);
    }

    // Agregamos el listener al scrollTarget.
    scrollTarget.addEventListener('scroll', handleScroll);

    // Función de limpieza para quitar el listener al desmontar.
    return () => {
      scrollTarget.removeEventListener('scroll', handleScroll);
    };
  // Se depende de callback y targetElement para actualizar el listener si alguno cambia.
  }, [callback, targetElement]);
}

export default useCloseOnScroll;
